// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"642fdbf2","161":"77a9a404","669":"37756aad"}[chunkId] + ".chunk.js";
};